import type { ReactElement } from 'react';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';
import type { SourceControlProvider } from '@/components/integrations/SourceControlIntegrationCard';

interface DisconnectDialogProps {
  provider: SourceControlProvider;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  readOnly?: boolean;
}

export function DisconnectDialog({
  provider,
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  readOnly,
}: DisconnectDialogProps): ReactElement {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            Disconnect {provider.displayName}?
          </AlertDialogTitle>
          <AlertDialogDescription>
            This will stop syncing {provider.displayName} members and remove
            unlinked imports from the Users list. Users who have linked their{' '}
            {provider.displayName} accounts will keep their accounts but
            won&apos;t receive future {provider.displayName} sync updates. The{' '}
            {provider.displayName} app will remain installed — you can reconnect
            at any time.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancel</AlertDialogCancel>
          <Button
            onClick={onConfirm}
            disabled={isLoading || (readOnly ?? false)}
            variant="destructive"
          >
            {isLoading ? 'Disconnecting...' : 'Disconnect'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
